import { stripPathLocale } from '../../../../common/localeShared';
import type { TUpsellQualificationRuntime } from '../types';

const COVERAGE_PAGE_PATH = '/the-venomous-abyss/global-coverage';

/**
 * The homepage already carries the RWF masthead, and the coverage page is this
 * upsell's own destination — suppress the banner on both so it only rotates on
 * the rest of the site.
 */
export function qualifyRwfVenomousAbyssCoverage(runtime: TUpsellQualificationRuntime): true | null {
  const pathname = stripPathLocale(runtime.pathname);

  const isHomePage = pathname === '' || pathname === '/';
  const isCoveragePage = pathname === COVERAGE_PAGE_PATH || pathname.startsWith(`${COVERAGE_PAGE_PATH}/`);

  return isHomePage || isCoveragePage ? null : true;
}
